import {
    Component,
    DoCheck,
    EventEmitter,
    Input,
    KeyValueDiffer,
    KeyValueDiffers,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {ShipmentRoute} from "../services/shipment-route";
import {ShipmentProductLine} from "../services/shipment-product-line";
import * as moment from "moment";
import {Shipment} from "../services/shipment";
import {ShipmentEventModalComponent} from "../shipment-event-modal/shipment-event-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentEvent} from "../services/shipment-event";
import {ShipmentProductLineModalComponent} from "../shipment-product-line-modal/shipment-event-modal.component";
import {PermissionsService} from "../permissions.service";
import {debounceTime, Subject, takeUntil} from "rxjs";

@Component({
    selector: '[app-shipment-product-line]',
    templateUrl: './shipment-product-line.component.html',
    styleUrls: ['./shipment-product-line.component.scss']
})
export class ShipmentProductLineComponent implements OnInit, OnChanges, DoCheck {

    @Input() actions: boolean;
    @Input() product_line: ShipmentProductLine;
    @Input() shipment: Shipment;
    @Input() i: number;
    @Input() showNumberPicked: boolean;
    @Input() hideEvents: boolean;
    @Input() hideNotes: boolean;
    @Input() hidePo: boolean;
    @Input() hideStock: boolean;
    @Input() showProductImage: boolean;
    @Input() hideAmount: boolean;
    @Input() hideWeight: boolean;
    @Input() showStockLocation: boolean = false;

    @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
    @Output() modalOpened: EventEmitter<any> = new EventEmitter<any>();
    editNote: boolean;
    @Input() inlineEdit!: boolean;
    private productLineDiffer: KeyValueDiffer<string, any>;

    private destroy$ = new Subject<void>();
    private manualScanChange$ = new Subject<number>();

    public setPickStatus(amount) {
        console.log('setPickStatus', amount);
        this.refresh.emit(amount);
    }

    constructor(
        public ngbModal: NgbModal,
        public shipmentsService: ShipmentsService,
        public permissionsService: PermissionsService,
        private differs: KeyValueDiffers
    ) {
    }

    ngOnInit() {
        this.manualScanChange$
            .pipe(
                debounceTime(700),
                takeUntil(this.destroy$)
            )
            .subscribe((manualScan: number) => {
                this.setManualScan(manualScan);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    protected manualScan: number = 0;
    protected showManualInput: boolean = false;

    protected manualScanChanged(manualScan: number) {
        this.showManualInput = true;
        this.manualScanChange$.next(manualScan);
    }

    protected setManualScan(manualScan: number) {
        if (manualScan === null) {
            return;
        }

        if (!this.shipment.is_internal_shipment && manualScan + this.product_line.amount_picked > this.product_line.amount) {
            alert('Manual scan exceeds product line amount');
            this.product_line.amount_scanned = this.product_line.amount - this.product_line.amount_picked;
        } else {
            this.product_line.amount_scanned = manualScan;
        }
        this.setPickStatus(this.product_line.amount_scanned);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.product_line) {
            this.productLineDiffer = this.product_line ? this.differs.find(this.product_line).create() : null;

            if (this.productLineDiffer) {
                this.productLineDiffer.diff(this.product_line);
            }
        }
    }

    ngDoCheck() {
        if (!this.productLineDiffer || !this.product_line) {
            return;
        }

        const changes = this.productLineDiffer.diff(this.product_line);

        if (changes) {
            changes.forEachChangedItem(change => {
                this.productLinePropertyChanged(change.key, change.previousValue, change.currentValue);
            });

            changes.forEachAddedItem(change => {
                this.productLinePropertyChanged(change.key, undefined, change.currentValue);
            });

            changes.forEachRemovedItem(change => {
                this.productLinePropertyChanged(change.key, change.previousValue, undefined);
            });
        }
    }

    private productLinePropertyChanged(property: string, previousValue: any, currentValue: any): void {
        console.log('product_line property changed', property, previousValue, currentValue);

        if (this.shipment.is_internal_shipment && property === 'amount_scanned' && this.showManualInput === false) {
            if (this.product_line.amount_scanned + this.product_line.amount_picked === this.product_line.amount) {
                this.showManualInput = true;
            }
        }
    }

    productLineStatusChange(shipmentProductLine: ShipmentProductLine): void {
        shipmentProductLine.note_modified = moment();
    }

    poUrl() {
        if (this.shipment && this.product_line.purchase_order) {
            if (this.shipment.branch) {
                return 'http://www.' + this.shipment.branch + '.b2b-10-4.dk/cgi-bin/ubus.cgi?krekonto=0&nasthtml=idaweben/koororho.html&kobornum=' + this.product_line.purchase_order + '&sidetype=koblinje';
            }
        }
    }

    quickAction(shipment_status, metadata:any) {
        let event = ShipmentEvent.fromJSON({
            foreign_key: this.product_line.id,
            model: 'ShipmentProductLines',
            date:  moment(),
            status_text: null,
            shipment_status: shipment_status,
        });

        if (metadata) {
            event['meta_data'] = metadata;
        }

        this.shipmentsService.createShipmentEvent(event).then(response => {
            this.shipmentsService.postShipmentChangedEvent(true);
        });
    }

    startCreateNewEvent() {
        const modalRef = this.ngbModal.open(ShipmentEventModalComponent, {size: 'sm'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment_product_line = this.product_line;
        // modalRef.componentInstance.saved = (result: Shipment) => {
        //     this.shipmentsService.postShipmentChangedEvent(true);
        // };
    }

    openEditShipmentProductLineModal() {
        this.modalOpened.emit(true);

        const modalRef = this.ngbModal.open(ShipmentProductLineModalComponent, {size: 'lg'});
        modalRef.componentInstance.modal = modalRef;
        modalRef.componentInstance.shipment_product_line = this.product_line;
        modalRef.componentInstance.shipment = this.shipment;
        modalRef.result.then(
            result => {
                this.modalOpened.emit(false);
                console.log('Modal closed med:', result)
            },
            reason => {
                this.modalOpened.emit(false);
                console.log('Modal dismissed med:', reason)
            }
        );
    }

    flashProductLine() {
        this.shipmentsService.flashShipment(this.shipment.id, [this.product_line.id])
    }

    adjustTextareaHeight(event: Event): void {
        const textarea = event.target as HTMLTextAreaElement;
        textarea.style.height = 'auto'; // Reset height to make it shrink if needed
        textarea.style.height = textarea.scrollHeight + 'px';
    }

    quickActionShipment(shipment_status, metadata:any) {
        let event = ShipmentEvent.fromJSON({
            foreign_key: this.product_line.shipment_id,
            model: 'Shipments',
            date:  moment(),
            status_text: null,
            shipment_status: shipment_status,
        });

        if (metadata) {
            event['meta_data'] = metadata;
        }

        this.shipmentsService.createShipmentEvent(event).then(response => {
            this.shipmentsService.postShipmentChangedEvent(true);
        });
    }

    protected setStopBlur($event: MouseEvent) {
        this.modalOpened.emit(true);

    }

    protected setStartBlur($event: FocusEvent) {
        this.modalOpened.emit(false);

    }
}
